import { useEffect, useState } from 'react';
import { fetchReadableArticle, type ReadableArticle } from '../lib/reading';

interface Props {
  url: string;
  onBack: () => void;
}

export function ReadingView({ url, onBack }: Props) {
  const [article, setArticle] = useState<ReadableArticle | undefined>();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setArticle(undefined);
    setError('');
    fetchReadableArticle(url)
      .then((item) => { if (!cancelled) setArticle(item); })
      .catch((err) => { if (!cancelled) setError(err instanceof Error ? err.message : 'Reading mode failed.'); });
    return () => { cancelled = true; };
  }, [url]);

  return (
    <div className="reading-view">
      <div className="reading-toolbar">
        <button onClick={onBack}>← Back to page</button>
        <span>Reading Mode</span>
      </div>
      {!article && !error && <div className="empty-state">Extracting readable content…</div>}
      {error && <div className="empty-state"><h2>Readable version unavailable</h2><p>{error}</p></div>}
      {article && (
        <article>
          <p className="eyebrow">{article.url}</p>
          <h1>{article.title}</h1>
          {article.paragraphs.map((paragraph, index) => <p key={`${index}-${paragraph.slice(0, 16)}`}>{paragraph}</p>)}
        </article>
      )}
    </div>
  );
}
